import type { HeroArticles } from "~~/shared/types/hero";

export function useHeroArticles() {
  const nuxtApp = useNuxtApp();
  return useAsyncData<HeroArticles>(
    "hero-articles",
    () => $fetch("/api/hero-article", { query: { locale: appLocale() } }),
    {
      default: () => ({ portrait: null, landscape: null }),
      getCachedData: (key) => nuxtApp.payload.data[key] ?? nuxtApp.static.data[key],
    }
  );
}
